<template>
  <div class="productList" ref="container">
    <form @submit.prevent="submitForm">
      <div class="search bg-color-red acea-row row-between-wrapper">
        <div class="input acea-row row-between-wrapper">
          <span class="iconfont icon-sousuo"></span>
          <input placeholder="搜索旗舰店信息" v-model="where.keyword" />
        </div>
      </div>
    </form>
    <div style="background-color: #f2f2f2;" class="list acea-row row-between-wrapper on" v-if="storeList.length > 0">
       <!-- <router-link
        :to="{
          path: '/ShopDetails/' + item.id
        }"
        class="item on"
        v-for="(item, index) in storeList"
        :key="index"
        :title="item.mch_name"
      > -->
      <router-link
        :to="{
         
        }"
        class="item on"
        style="margin-bottom:.2rem"
        v-for="(item, index) in storeList"
        :key="index"
        :title="item.mch_name"
        
      >
        <!-- <div class="pictrue on">
          <img :src="item.mch_pic" v-if="item.mch_pic!=null" class="on" />
          <img src="@assets/images/merch-logo.jpg" v-if="item.mch_pic==null" class="on" />
        </div> -->
        <!-- <div v-if="item.distance>0" > -->
        <div class="text on" >
          <div  class="box-to">
          <div class="men_logo"><img src="http://tieyige.fsrcwl.cn/images/logo.jpg"/></div>
           <span class="name line1">{{ item.mch_name }}</span>
          <div class="label">上门贴膜</div>
          </div>
          <div class="vip acea-row row-between-wrapper on">
            <div class="vip-money">
              {{ item.mch_address }}
            </div>
            <!-- <div v-if="item.distance==0">未开启定位</div> -->
            <div >距离{{ item.distance }}km</div>
          </div>
        </div>
        <div style="display:flex;">
        <a   class="function" v-on:click="See(index)">
          <img src="http://tieyige.fsrcwl.cn/images/dianh.png" />地址导航
        </a>

      
        <div class="fun-line"></div>
        <a class="function" v-on:click="phoneCall(item.phone)" >
          <img src="http://tieyige.fsrcwl.cn/images/daoh.png" />电话联系
        </a>
      
      </div>
      <!-- </div> -->
      </router-link>

      
    </div>
    <!-- <Loading :loaded="loadend" :loading="loading"></Loading> -->
    <div
      class="noCommodity"
      v-cloak
      style="background-color: #f5f5f5;"
      v-if="storeList.length === 0 && where.page > 1"
    >
    </div>
  </div>
</template>
<script type="text/javascript" src="http://res.wx.qq.com/open/js/jweixin-1.6.0.js"></script>
<script>
import { getMerch } from "@api/store";
import debounce from "lodash.debounce";
import Loading from "@components/Loading";
import BaiduMap from "@api/map";
import { isWeixin } from "@utils/index";
import { wechatEvevt } from "@libs/wechat";
export default {
  components: {
    Loading
  },
  props: {},
  data: function() {
    const { s = "", title = "" } = this.$route.query;

    return {
      storeList: [],
      where: {
        page: 1,
        limit: 8,
        keyword: s,
        lat:'',//纬度
        lng:''//经度
      },
      title: title ? title : "",
      loadTitle: "",
      loading: false,
      loadend: false,
    };
  },
  watch: {
    title() {
      this.updateTitle();
    },
    $route(to) {
      if (to.name !== "GoodsList") return;
      const { s = "", title = "" } = to.query;

      if (s !== this.where.keyword) {
        this.where.keyword = s;
        this.loadend = false;
        this.loading = false;
        this.where.page = 1;
        this.title = title ? title : "";
        this.$set(this, "storeList", []);
        this.getStoreList();
      }
    }
  },
  mounted: function() {
     var that = this;
    that.$nextTick(() => {
      that.getLocation(); // 调用获取地理位置
    });
    that.updateTitle();
    // this.getStoreList();
  },
  methods: {
    getLocation() {
      var that = this;
      BaiduMap.init().then((BMap) => {
        console.log("加载成功...")
        var map = new BMap.Map("allmap");
        var geolocation = new BMap.Geolocation();
        geolocation.getCurrentPosition(function(r){
          if(this.getStatus() == BMAP_STATUS_SUCCESS){
            that.where.lat = r.point.lat;
            that.where.lng = r.point.lng;
          }else {
            console.log(this.getStatus());
          }  
          that.getStoreList();      
        });
      })
    },

    updateTitle() {
      document.title = this.title || this.$route.meta.title;
    },
    getStoreList:debounce(function () {
      var that = this;
      if (that.loading) return; //阻止下次请求（false可以进行请求）；
      if (that.loadend) return; //阻止结束当前请求（false可以进行请求）；
      that.loading = true;
      let q = that.where;
      getMerch(q).then(res=>{
        that.loading = false;
        that.storeList.push.apply(that.storeList, res.data);
        that.loadend = res.data.length < that.where.limit; //判断所有数据是否加载完成；
        that.where.page = that.where.page + 1;
        console.log(res.data)
      });
    }, 300),
    submitForm: function() {
      this.$set(this, "storeList", []);
      this.where.page = 1;
      this.loadend = false;
      this.loading = false;
      this.getStoreList();
    },
     phoneCall: function (msg) {
      console.log(msg)
      window.location.href = 'tel:'+msg
    },
    See : function (index) {
      console.log(index);
      var longitude=this.storeList[index].longitude;
      var latitude=this.storeList[index].latitude;
      // var mch_name=encodeURI(this.storeList[index].mch_name);//文本转码
      // var mch_address=encodeURI(this.storeList[index].mch_address);
      var mch_name=this.storeList[index].mch_name;//文本转码
      var mch_address=this.storeList[index].mch_address;
      console.log(longitude,latitude,mch_name,mch_address)  
      if (isWeixin()) {
        let config = {
          latitude: parseFloat(latitude),
          longitude: parseFloat(longitude),
          name: mch_name,
          address: mch_address
        };
        wechatEvevt("openLocation", config)
          .then(res => {
            console.log(res);
          })
          .catch(res => {
            if (res.is_ready) {
              res.wx.openLocation(config);
            }
          });
       }
      else {
        if (!this.mapKey)
          return this.$dialog.error(
            "暂无法使用查看地图"
          );
        this.mapShow = true;
      }
    },
  }
};
</script>

<style scoped>
body{
  background-color: #f5f5f5!important;
}
.men_logo{
  float: left;
  width:35px;
  height: 35px;
  overflow: hidden;
}
.men_logo img{
  width:100%;
  height: 100%;
  overflow: hidden;
  border-radius: 50%;
}
.function{
  width: 49%;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
}
.function img{
  width: 18px;
  height: 18px;
  margin-right: .1rem;
}
.fun-line{
  display: inline-flex;
  height: 42px;
  width: 1px;
  border:1px solid #f2f2f2;;
  padding: .2rem 0;
}
.noCommodity {
  border-top: 3px solid #f5f5f5;
  padding-bottom: 1px;
}
.productList .list.on{
  margin-top: 1rem;
  margin-bottom: 1.2rem;
}
.productList .search{
  padding-left: 0;
}
.productList .search .input{
  width: 90%;
  margin: auto;
}
.productList .list .item .text .vip.on{
  /* margin-top: .8rem; */
  letter-spacing: .015rem;
  padding-right: .1rem;
}
.productList .list{padding:.1rem 0.2rem;margin-top:1.72rem;background-color: unset;}
.productList .list .item.on{width:100%;display:block;border-bottom:unset;margin:0;padding: .1rem 0;}
.productList .list .item .text.on{border-bottom:1px solid #f2f2f2}
.productList .list .item .text .label{border-radius: 4px;float: right;margin-top: .15rem; font-size: .24rem;display: inline-block;padding: .02rem .05rem;margin-right: .1rem;border: 1px solid #ff314f;color: #ff314f;}
.productList .list .item.on{padding:unset}
.productList .list .item .text .vip.on{padding-bottom: .1rem;}
.productList .list .item .text.on{border-bottom:1px solid #f2f2f2}
.box-to{height:auto;overflow:hidden;}
.line1{line-height: 35px;margin-left: .1rem;}
</style>
